import React from 'react';
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-react';

import useTheme from '../SharedUtils/hooks';
import { getThemeProperties } from '../SharedUtils/utils';

import './IconTeaserCard.css';

const IconTeaserCard = ({ fields }) => {
  let widgetStyleList = {};
  const { isLight } = useTheme();
  const themeClass = isLight ? 'is-theme-light' : 'is-theme-dark';
  const themeProperties = getThemeProperties(fields, isLight);

  if (themeProperties.TextColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-textColor'] = themeProperties.TextColor?.value;
  }
  if (themeProperties.TextHoverColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-textHoverColor'] = themeProperties.TextHoverColor?.value;
  }
  if (themeProperties.DescriptionColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-descriptionColor'] =
      themeProperties.DescriptionColor?.value;
  }
  if (themeProperties.DescriptionHoverColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-descriptionHoverColor'] =
      themeProperties.DescriptionHoverColor?.value;
  }
  if (themeProperties.borderColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-borderColor'] = themeProperties.borderColor?.value;
  }
  if (themeProperties.borderHoverColor?.value !== '') {
    widgetStyleList['--icon-teaser-card-borderHoverColor'] =
      themeProperties.borderHoverColor?.value;
  }
  if (themeProperties.BackgroundColour !== null) {
    widgetStyleList['--icon-teaser-card-BackgroundColour'] =
      themeProperties.BackgroundColour?.fields?.HexColorCode?.value;
  }
  if (themeProperties.BackgroundHoverColour !== null) {
    widgetStyleList['--icon-teaser-card-BackgroundHoverColour'] =
      themeProperties.BackgroundHoverColour?.fields?.HexColorCode?.value;
  }
  if (fields.borderRadius?.value !== '') {
    widgetStyleList['--icon-teaser-card-borderRadius'] = fields.borderRadius?.value;
  }

  return (
    <div
      data-component="IconTeaserCard"
      className={`o-widget c-iconTeaserCard  ${themeClass}`}
      style={widgetStyleList}
    >
      <a href={fields.CallToAction?.value?.href || '#'} className="card">
        <div className="c-iconTeaserCard__image">
          <Image field={fields.Image} />
        </div>
        <div className="c-iconTeaserCard__content">
          <Text field={fields.Headline} tag="h3" className="c-iconTeaserCard__title" />
          <RichText field={fields.Description} className="c-iconTeaserCard__description" />
        </div>
      </a>
    </div>
  );
};

export default IconTeaserCard;
